var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PopinCalendar',{attrs:{"date":_vm.model,"columns":2,"disabled-today":_vm.disabledToday,"display-hours":_vm.displayHours},on:{"change":e => _vm.change(e)}},[_c('Field',{staticClass:"field-date",attrs:{"type":"text","icon":"calendar","required":_vm.required,"name":_vm.name,"label":_vm.label,"model":_vm.dateFormat}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }